import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {PhoneNumberFormat, PhoneNumberUtil} from "google-libphonenumber";
import {FormControl, FormGroup} from "@angular/forms";
import {ConstantsService} from "../../../../services/constants/constants.service";
import { PermissionsService } from "../../../../services/permissions/permissions.service";

@Component({
  selector: 'app-edit-reference-recipient',
  templateUrl: './edit-reference-recipient.component.pug',
  styleUrls: ['./edit-reference-recipient.component.scss'],
  standalone: false
})
export class EditReferenceRecipientComponent implements OnInit {

  @Input() recipientToEdit: any;
  @Input() isReference = true;
  @Output() closeEditEvent = new EventEmitter();
  @Output() updatedRecipient = new EventEmitter();
  recipientRow:any = {};
  closeComponent = false;
  recipientLastName!: string;
  disableSend = true;
  @ViewChild("editReferenceRecipientForm") editRecipient: any;
  phoneUtil = PhoneNumberUtil.getInstance();
  errorMessage = {
    'type': '',
    'message': ''
  };
  TRUST_752_VERIFICATION = false;
  requestTemplate = false;

  constructor(private permissions: PermissionsService) {
  }

  ngOnInit(): void {
    this.TRUST_752_VERIFICATION = this.permissions.isFeatureActivated('trust-752-certn-checks');
    this.requestTemplate = this.permissions.isFeatureActivated('ent-10605-request-templates');
    this.recipientRow = {...this.recipientToEdit['recipient']};
    this.disableCheck();
  }

  isDirty(): boolean {
    return this.editRecipient.markAsDirty();
  }

  closeEdit() {
    this.closeComponent = true;
    this.closeEditEvent.emit(this.closeComponent);
  }

  disableCheck() {
      if(this.requestTemplate){
          if (this.recipientRow.first_name?.trim() && this.recipientRow.last_name?.trim() && this.recipientRow.email && this.recipientRow.mobile_phone && (!this.isReference || (this.isReference && this.recipientRow?.checks?.xref_open_api?.internal_reference?.trim()))) {
              this.disableSend = false;
          } else this.disableSend = true;
      }
      else {
          if (this.recipientRow.first_name?.trim() && this.recipientRow?.last_name.trim() && this.recipientRow.email && this.recipientRow.mobile_phone && this.recipientRow?.checks?.xref_open_api?.internal_reference?.trim()) {
              this.disableSend = false;
          } else this.disableSend = true;
      }

  }
  disableCheckAndCheckRoleLength() {
      if(this.requestTemplate){
          if (this.isReference && this.recipientRow['checks']['xref_open_api']['internal_reference'].length > 255) {
              this.errorMessage = {
                  'type': 'danger',
                  'message': ConstantsService.maxLength
              };
              this.disableSend = true;
              return;
          }
          this.disableCheck();
      }
      else {
          if (this.recipientRow['checks']['xref_open_api']['internal_reference'].length > 255) {
              this.errorMessage = {
                  'type': 'danger',
                  'message': ConstantsService.maxLength
              };
              this.disableSend = true;
          }
          if (this.recipientRow.first_name?.trim() && this.recipientRow?.last_name.trim() && this.recipientRow.email && this.recipientRow.mobile_phone && this.recipientRow?.checks?.xref_open_api?.internal_reference?.trim()) {
              this.disableSend = false;
          } else this.disableSend = true;
      }


  }

  checkClass(recipient, fields) {
    for (let field of fields) {
      if (recipient.meta.error_fields.indexOf(field) != -1) {
        return 'error';
      } else if (recipient.meta.warning_fields.indexOf(field) != -1) {
        return 'warning';
      }
    }
    return 'none';
  }

  saveDetails(recipient) {
    let payloadToEdit = {
      "recipient": recipient,
    }
    if(this.requestTemplate){
        if ((!this.isReference || (this.isReference && recipient['checks']['xref_open_api']['internal_reference'])) && recipient['first_name'] && recipient['last_name'] && recipient['email'] && this.recipientRow['mobile_phone']) {
            if(this.isReference){
                payloadToEdit['recipient']['internal_reference'] = recipient['checks']['xref_open_api']['internal_reference']
            }
            delete payloadToEdit['recipient']['checks']
            this.disableSend = false;
            this.updatedRecipient.emit(payloadToEdit);
            this.closeEdit();
        }
    }
    else {
        if (recipient['checks']['xref_open_api']['internal_reference'] && recipient['first_name'] && recipient['last_name'] && recipient['email'] && this.recipientRow['mobile_phone']) {
            payloadToEdit['recipient']['internal_reference'] = recipient['checks']['xref_open_api']['internal_reference']
            payloadToEdit['recipient']
            delete payloadToEdit['recipient']['checks']
            this.disableSend = false;
            this.updatedRecipient.emit(payloadToEdit);
            this.closeEdit();
        }
    }
  }

  phoneUpdate(event) {
    this.editRecipient.control.markAsDirty();
    this.recipientRow['country_code'] = event['country_code'];
    this.recipientRow['mobile_phone'] = event['mobile_phone'] === 'null' ? '' : event['mobile_phone'];
    let phone = event['country_code'] + event['mobile_phone'];
    let parsedPhone = '';
    try {
      parsedPhone = this.phoneUtil.parseAndKeepRawInput(phone);
      this.recipientRow['mobile'] = this.phoneUtil.format(parsedPhone, PhoneNumberFormat.INTERNATIONAL);
    } catch (e) {
      // needs to be handled in a better way
      console.log("Phone number parsing error: ", e);
    }
    this.disableCheck();
  }

}
